import { InterestRateParams } from 'app/models/interest-rate'

export const getInterestRatess = (state: {
  interestRates: { interestRates: InterestRateParams[] }
}) => state.interestRates.interestRates
